import axios from 'axios'
const URL_API = process.env.NEXT_PUBLIC_URL_API?.trim() || undefined

export const api = axios.create({
  baseURL: URL_API,
  // A request must always settle: the single-flight order guards (one per
  // funnel) release only when their thunk's promise settles, so a stalled
  // order POST without a deadline would block every later submission in that
  // funnel until reload. Provider-backed reads can exceed this deadline too.
  timeout: 45_000,
})

// Report route templates only: URLs can contain emails, searches and cart IDs.
const timeoutRoutes = [
  'leads', 'leads/searched-companies/hot',
  'coupons/current-active-banner', 'coupons/check-code', 'price-tier',
  'email/is-whitelisted', 'email/is-blacklisted', 'ab-testing/all',
  'affiliates/referral', 'cart-share', 'cart-share/:uuid',
  'persistent-cart/get-uuid', 'persistent-cart/:uuid',
  'trust-pilot/search', 'trust-pilot/orders',
  'trust-pilot/:company', 'trust-pilot/:company/reviews',
]

api.interceptors.request.use((config) => {
  const segments = (config.url ?? '').split(/[?#]/, 1)[0].replace(/^\//, '').split('/')
  const route = timeoutRoutes.find((template) => {
    const parts = template.split('/')
    return parts.length === segments.length && parts.every((part, index) =>
      part.startsWith(':') ? Boolean(segments[index]) : part === segments[index],
    )
  }) ?? 'unknown-route'
  const method = (config.method ?? 'get').toUpperCase()

  config.timeoutErrorMessage ??= `timeout of ${config.timeout}ms exceeded (${method} ${route})`
  return config
})
